export default ({ t, accountScopedRoute, hasMcpClient, isAdmin }) => ({
  name: 'Settings Integrations',
  label: t('SIDEBAR.INTEGRATIONS'),
  icon: 'i-ph-plugs',
  defaultFolded: true,
  children: [
    {
      name: 'Settings Apps',
      label: t('SIDEBAR.APPS'),
      icon: 'i-ph-squares-four',
      to: accountScopedRoute('settings_applications'),
    },
    {
      name: 'Settings Webhooks',
      label: t('SIDEBAR.WEBHOOKS'),
      icon: 'i-ph-webhooks-logo',
      to: accountScopedRoute('settings_integrations_webhook'),
    },
    {
      name: 'Settings Agent Bots',
      label: t('SIDEBAR.AGENT_BOTS'),
      icon: 'i-ph-robot',
      to: accountScopedRoute('agent_bots'),
    },
    ...(hasMcpClient && isAdmin
      ? [
          {
            // Remote MCP servers Tola AI may call out to. Admin-only like the
            // route it points at, and absent while `tola_ai_mcp_client` is off
            // - the same two gates the controller applies.
            name: 'Settings MCP Connectors',
            label: t('SIDEBAR.MCP_CONNECTORS'),
            icon: 'i-ph-plug',
            to: accountScopedRoute('settings_mcp_connectors'),
          },
        ]
      : []),
  ],
});
